/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { parseDependencies } from './dependenciesParse.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createEvaluate } from '../../factoriesNumber.js';
export var evaluateDependencies = {
  parseDependencies,
  typedDependencies,
  createEvaluate
};